module.exports = __webpack_public_path__ + "static/media/screenshot-performance.ad5cf372.png";